/**
 * «کاربر این تنظیم را عوض کرد» — یک قلابِ خالی که `lib/` صدا می‌زند.
 *
 * ═══ چرا یک قلاب و نه صدا زدنِ مستقیمِ مخزن ═══
 *
 * تنظیم‌ها در `lib/` می‌نشینند و `lib/` عمداً به شبکه دست نمی‌زند — کامنتِ
 * بالای `cityScope.ts` صریح می‌گوید «خالص مونده تا تستش بدونِ هیچ بک‌اندی
 * اجرا شه». یک `import` از `data/prefLogRepo` در `lib/theme.ts` همان لحظه
 * کلاینتِ Supabase را وارد گرافِ تستِ واحد می‌کرد.
 *
 * پس `lib/` فقط `recordPref()` را صدا می‌زند که تا وقتی کسی چیزی نصب نکرده
 * **هیچ کاری نمی‌کند**، و اپ سرِ بوت پیاده‌سازیِ واقعی را می‌نشاند. همان
 * الگوی `ports.ts`، در مقیاسِ کوچک‌تر.
 *
 * ═══ جریان یک‌طرفه است ═══
 *
 * این‌جا فقط **نوشته** می‌شود. هیچ تنظیمی از سرور خوانده و به کاربر تحمیل
 * نمی‌شود؛ مرجعِ هر تنظیم همان حافظه‌ی دستگاه است که همیشه بود. تنها
 * استثنا `locale` است که تریگرهای اعلان می‌خوانندش (مایگریشن ۰۱۰۹) — و
 * آن هم فقط نوشته می‌شود، از همین‌جا.
 */

/** نامِ تنظیم، همان‌طور که در `user_pref_events.key` می‌نشیند. */
export type PrefKey =
  | 'locale'
  | 'theme'
  | 'discoverView'
  | 'discoverSort'
  | 'traceLog'
  | 'cityHome'
  | 'cityTemp'
  | 'noFriendsNotice'
  | 'pushPermission'
  /** تورِ کاربرِ تازه: `'done'` تا آخر رفت، `'skipped'` وسطِ راه ردش کرد. */
  | 'tour';

export type PrefSink = (key: PrefKey, value: unknown) => void;

const noop: PrefSink = () => undefined;

let sink: PrefSink = noop;

/**
 * پیاده‌سازیِ واقعی را می‌نشاند. اپ‌ها سرِ بوت صدایش می‌زنند
 * (`apps/web/src/boot.ts` و `apps/mobile/src/native/bootstrap.ts`).
 */
export const setPrefSink = (fn: PrefSink | null): void => { sink = fn ?? noop; };

/**
 * ثبت — بی‌صدا و بدونِ انتظار.
 *
 * ⚠ هیچ‌وقت throw نمی‌کند و هیچ‌وقت await نمی‌شود: این یک یادداشتِ کناری
 * است، و شکستنِ «تمِ تیره را انتخاب کن» به‌خاطرِ یک اینترنتِ قطع، دقیقاً
 * همان چیزی است که نباید بشود.
 */
export const recordPref = (key: PrefKey, value: unknown): void => {
  try {
    sink(key, value);
  } catch {
    // ثبت نشد. خودِ تنظیم از قبل اعمال شده و کاربر چیزی نمی‌بیند.
  }
};
